/* eslint-disable */
import styled from 'styled-components'

export const BiodiversitySelectorWrapper = styled.div`
  width: 100%;
  padding: 0 30px;


`

export const TitleContainer = styled.div`
  text-align: center;
  margin-bottom: 16px;
  h3 {
    font-weight: 700;
    font-size: 18px;
  }
`

export const InfoContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: start;
    gap: 8px;
    margin-bottom: 18px;

  p {
    text-align: center;
    color: #333333;
  }
`

export const SelectAllContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;  /* space between items */
  margin-bottom: 20px;

  label {
    display: flex;
    align-items: center;
    cursor: pointer;


  input[type='checkbox'] {
    transform: scale(1.1);
    cursor: pointer;
  }

    span {
      margin-left: 8px;
      font-size: 14px;
      font-weight: 500;
      color: #333;
    }
  }
`;

export const SelectTypeWrapper = styled.div`
  display: flex;
 align-items: center;
  gap: 8px;
  margin-left: auto;
   justify-content: flex-end;
   margin-bottom: 20px;

  .showing-label {
    font-size: 14px;
    font-weight: 500;
    color: #646464;
    padding-right: 8px;
    white-space: nowrap;
  }

  }
`;


export const ActionButton = styled.button`
  background-color: #0AA1F4;
  color: white;
  padding: 8px 10px;
  font-size: 14px;
  border-radius: 3px;
  border: none;
  cursor: pointer;
  transition: opacity 0.2s;
  margin-left: auto;
  width: 100%;            /*  FIXED WIDTH */
  display: flex;
  justify-content: center;

  &:hover:not(:disabled) {
    opacity: 0.85;
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export const ViewButton = styled.button`
  background-color: white;
  color: #797979;
  padding: 8px 10px;
  font-size: 14px;
  border-radius: 3px;
  border: 1px solid #797979;
  cursor: pointer;
  transition: opacity 0.2s;
  margin-left: auto;
  width: 170px;            /*  FIXED WIDTH */
  display: flex;
  justify-content: center;

  &:hover:not(:disabled) {
    opacity: 0.85;
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export const ButtonContent = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const IconSlot = styled.span`
  width: 20px;             /* 🔑 ICON SPACE RESERVED */
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const TextSlot = styled.span`
  white-space: nowrap;     /* 🔑 Prevent wrap */
`;

export const GlobalSelectAll = styled.div`
  margin-left: auto;
  padding: 6px 12px;
  border-radius: 2px;
  font-size: 14px;
  font-weight: 500;
  color: #0aa1f4;
  cursor: pointer;


  &.disabled {
    color: #9ca3af;
    cursor: not-allowed;
    pointer-events: none;
    background: transparent;
  }
`


export const ItemWrapper = styled.div`
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid rgba(32, 32, 32, 0.1);

border-top: ${props => (props.showBorderTop === false ? "none" : "1px solid rgba(32, 32, 32, 0.1)")};

  padding:18px 0;
  gap: 16px;
  flex-wrap: wrap;

  .line{
   border-bottom: 1px solid rgba(32, 32, 32, 0.1);
  }

  .item-left {
    display: flex;
    align-items: center;
    gap: 16px;
    flex: 1;
    min-width: 200px;
  }

  .item-info {
    display: flex;
    align-items: center;
    gap: 8px;
    // flex-wrap: wrap;
    padding:4px;
    cursor: pointer;

  }

  .item-name {
    font-weight: 500;
    color: #333333;
    width: 310px;
  }

    .item-group-name {
    font-weight: 500;
    color: #333333;
    width: auto;
  }

  // .item-name span {
  //   display: block;
  // }

  .item-name span + span {
      margin-left: 8px;
  }
  .status-dot {
    width: 8px; /* Adjust size as needed */
    height: 8px; /* Adjust size as needed */
    border-radius: 50%;
    background-color: #cfcfcf; /* Grey color for inactive */
  }

  .status-dot.grey {
  background-color: #cfcfcf; /* default grey */
}

.status-dot.green {
  background-color: #2ecc71; /* bright green */
}

.status-dot.blue {
  background-color: #0AA1F4; /* bright green */
}

  .item-type {
    font-size: 14px;
    color: #333333;
  }

  .item-right {
    display: flex;
    align-items: center;
    gap: 16px;
    flex-shrink: 0;

    .calendar-section {
      display: flex;
      align-items: center;

    }
  }

  input[type='checkbox'] {
    transform: scale(1.1);
    cursor: pointer;
  }

  .edit-btn-style {
  background-color: transparent !important;
  border: 1px solid #ddd !important;
  box-shadow: 0 0 4px rgba(0,0,0,0.15);
  color: #777 !important;
}

.edit-btn-style svg {
  stroke: #777 !important; /* icon colour */
}

.tree-group-header {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 0;
  font-weight: 600;
  border-top: 1px solid #eee;
}

.tree-child {
  padding-left: 28px;
}



`;

export const TabsWrapper = styled.div`
  display: flex;
  gap: 16px;
  margin-bottom: 20px;
  border-bottom: 1px solid rgba(32, 32, 32, 0.1);
`;

export const Tab = styled.div`
  padding: 8px 16px;
  cursor: pointer;
  border-bottom: 2px solid transparent;
  font-weight: 500;

  &.active {
    border-bottom: 2px solid #0aa1f4;
    color: #0aa1f4;
  }
`;



export const PaginationWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 20px 0;
  padding-top: 16px;
`